import { ReCaptchaModal } from './ReCaptchaModal';

export { useRecaptchaController } from './useRecaptchaController';
export default ReCaptchaModal;
